import React, { Component } from 'react';

// Store in store list.
class Store extends Component {


	makeSafeForCSS(name) {
		return name.replace(/[^a-z0-9]/g, function(s) {
		    var c = s.charCodeAt(0);
		    if (c === 32) return '-';
		    if (c >= 65 && c <= 90) return '_' + s.toLowerCase();
		    return '__' + ('000' + c.toString(16)).slice(-4);
		});
	}

	render() {

		const store = this.props.data;
		const locLink = 'https://maps.google.com/?q='+ encodeURIComponent( store.Address );
		const storeId = this.makeSafeForCSS( store.Address );

		return (
			<li id={storeId} className="tk-store-locator__store">

				<h3 className="tk-store-locator__store-header"><a href={locLink} target="_blank" >{store.Name}</a></h3>
				
				<p><i className="fa fa-map-marker "></i> <a href={locLink} target="_blank" >{store.Address}</a></p>

				{ store["Phone Number"]
					? <p><i className="fa fa-phone"></i> {store["Phone Number"]}</p>
					: <span></span>
				}

				<div className="tk-store-locator__store-icons clearfix">
					<div className="tk-store-locator__store-icon"><a href={locLink} target="_blank" ><i className="fa fa-map-marker "></i> <span className="visuallyhidden">{store.Address}</span></a></div>
					
					{ store.Email
						? <div className="tk-store-locator__store-icon"><a href={ 'mailto:' + store.Email } alt="Email" ><i className="fa fa-envelope"></i> <span className="visuallyhidden">{ store.Email }</span></a></div>
						: <span></span>
					}

					{ store.Website
						? <div className="tk-store-locator__store-icon"><a href={store.Website} target="_blank" alt="Website" ><i className="fa fa-link"></i> <span className="visuallyhidden">{store.Website}</span></a></div>
						: <span></span>
					}
				</div>

			</li>
		);
	}
}

export default Store;



// WEBPACK FOOTER //
// ./src/js/Store.js